import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CheckCircle } from "lucide-react";

export default function OrderConfirmation() {
  const { completedOrderId } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-20">
      <div className="text-center">
        <CheckCircle className="w-20 h-20 text-green-600 mx-auto mb-6" />
        <h1 className="text-4xl font-bold mb-4">Order Confirmed!</h1>
        <p className="text-lg">Your Order ID: {completedOrderId}</p>

        <button
          onClick={() => navigate("/tracking/" + completedOrderId)}
          className="w-full bg-black text-white py-3 rounded font-medium mt-6 hover:bg-gray-800 transition"
        >
          Track Your Order
        </button>
      </div>
    </div>
  );
}
